module.exports = __webpack_public_path__ + "static/media/chilligarlicprawns.dc6ef4a3.jpg";